import { Component } from '@angular/core';
import { NotificationService } from "../../../services/notification.service";
import { CITIZEN_UPGRADE_TO_SERVANT_MUTATION } from "../../../guest/user-profile/user-profile.graphql";
import { map } from "rxjs/operators";
import { Apollo } from "apollo-angular";

@Component({
  selector: 'app-update-public-servant',
  templateUrl: './update-public-servant.component.html',
  styleUrls: ['./update-public-servant.component.scss']
})
export class UpdatePublicServantComponent {
  isSubmitting = false;

  constructor(
    private notificationService: NotificationService,
    private apollo: Apollo
  ) {}

  async confirmUpdate(isServant) {
    this.isSubmitting = true;
    const success = await this.citizenUpgradeToServantMutation(isServant);
    this.isSubmitting = false;
    if (success) {
      this.notificationService.successMessage('You have successfully updated to a Public Servant.');
      // location.href = '/tgsd-landing';
    }
    location.href = '/client-services';
  }

  async citizenUpgradeToServantMutation(isServant:boolean): Promise<boolean> {
    const data: any = await this.apollo.mutate({
      mutation: CITIZEN_UPGRADE_TO_SERVANT_MUTATION,
      fetchPolicy: 'network-only',
      variables: {isServant: isServant}
    }).pipe(
      this.notificationService.catchError('Error Updating Profile'),
      map((response) => {
        const result = Object.values(response)[0]?.citizenUpgradeToServantMutation;
        if (result?.response?.status) return true;
        this.notificationService.errorMessage(`${result?.response?.message} code: ${result?.response?.code}`);
        return false;
      })
    ).toPromise();

    return data;
  }
}
